import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";
import { SoftwareCard } from "../components/SoftwareCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/categories/${slug}`).then(({ data }) => setData(data)).catch(() => setData({ notFound: true }));
  }, [slug]);

  useSEO({
    title: data?.category ? `${data.category.name} Software for Pool Service` : "Category",
    description: data?.category?.description,
  });

  if (!data) return <div className="max-w-3xl mx-auto px-4 py-32 text-center text-slate-400">Loading…</div>;
  if (data.notFound) return <div className="max-w-3xl mx-auto px-4 py-32 text-center text-slate-500">Category not found.</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16" data-testid="category-page">
      <p className="uppercase tracking-[0.2em] text-xs font-semibold text-sky-600 mb-2">Category</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-slate-900">{data.category.name}</h1>
      <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">{data.category.description}</p>

      <h2 className="font-heading text-lg font-bold text-slate-900 mt-14 mb-6">Top software for {data.category.name.toLowerCase()}</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {data.software.map((s, i) => (
          <SoftwareCard key={s.slug} software={s} rank={i + 1} />
        ))}
        {data.software.length === 0 && <p className="text-slate-400">No published software in this category yet.</p>}
      </div>

      {data.articles.length > 0 && (
        <>
          <h2 className="font-heading text-lg font-bold text-slate-900 mt-16 mb-6">Guides on {data.category.name.toLowerCase()}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {data.articles.map((a) => (
              <Link key={a.slug} to={`/guides/${a.slug}`} data-testid={`category-article-${a.slug}`}
                className="group bg-white rounded-2xl border border-border p-6 hover:border-sky-300 hover:shadow-lg hover:shadow-sky-100 transition-shadow duration-200">
                <h3 className="font-heading font-bold text-slate-900 group-hover:text-sky-600 transition-colors duration-200 leading-snug">{a.title}</h3>
                <p className="text-sm text-slate-500 mt-2 line-clamp-2 leading-relaxed">{a.excerpt}</p>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
